import React from 'react';
import { Users, Target, CheckCircle, Briefcase } from 'lucide-react';
import WorkspaceHeader from './WorkspaceHeader';
import CustomersHub from '../sales/CustomersHub';
import SalesOverview from '../sales/SalesOverview';

interface SalesWorkspaceProps {
  activeArea: string;
}

export default function SalesWorkspace({ activeArea }: SalesWorkspaceProps) {
  const renderContent = () => {
    switch (activeArea) {
      case 'customers':
        return (
          <>
            <WorkspaceHeader
              title="Customer Hub"
              icon={Users}
              description="Manage your customer relationships and grow your business"
            />
            <CustomersHub />
          </>
        );
      case 'overview':
      default:
        return (
          <>
            <WorkspaceHeader
              title="Sales Floor Overview"
              icon={Target}
              description="Your sales and customer relationship command center"
            />
            <SalesOverview />
          </>
        );
    }
  };

  return renderContent();
}